import { ModuleId } from '../const'


export function configNavs(i18nMessage, loggedInUser) {

  const navConf = [
    {
      module: ModuleId.BoMember,
      group: i18nMessage.Backoffice,
      items: [
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.BoMembers,
          to: '/bo-member',
          icon: 'cil-people'
        },
      ],
    },
    {
      module: ModuleId.PageBuilder,
      group: i18nMessage.Page,
      items: [
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.PageBuilders,
          to: '/page-builder',
          icon: 'cil-browser'
        },
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.SectionBuilders,
          to: '/section-builder',
          icon: 'cil-library'
        },
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.GlobalStyles,
          to: '/global-style',
          icon: 'cil-library'
        },
      ],
    },
    {
      module: ModuleId.PageBuilderEditor,
      group: i18nMessage.Page,
      items: [
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.SectionEditor,
          to: '/section-builder-editor',
          icon: 'cil-library'
        },
      ],
    },
    {
      module: ModuleId.Member,
      group: i18nMessage.Member,
      items: [
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.Members,
          to: '/member',
          icon: 'cil-people'
        },
      ],
    },
    {
      module: ModuleId.Course,
      group: i18nMessage.Course,
      items: [
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.CourseTeachers,
          to: '/course-teacher',
          icon: 'cil-school'
        },
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.CourseCategories,
          to: '/course-category',
          icon: 'cil-clear-all'
        },
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.Courses,
          to: '/course',
          icon: 'cil-school'
        },
      ],
    },
    {
      module: ModuleId.CourseOrder,
      group: i18nMessage.Course,
      items: [
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.CourseOrders,
          to: '/course-order',
          icon: 'cil-calendar-check'
        },
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.CourseCalendar,
          to: '/course-calendar',
          icon: 'cil-calendar'
        },
      ],
    },
    {
      module: ModuleId.Product,
      group: i18nMessage.Product,
      items: [
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.ProductCategories,
          to: '/product-category',
          icon: 'cil-clear-all'
        },
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.Products,
          to: '/product',
          icon: 'cil-cart'
        },
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.ProductCoupons,
          to: '/product-coupon',
          icon: 'cil-gift'
        },
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.ProductShippings,
          to: '/product-shipping',
          icon: 'cil-truck'
        },
      ],
    },
    {
      module: ModuleId.ProductOrder,
      group: i18nMessage.Product,
      items: [
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.ProductOrders,
          to: '/product-order',
          icon: 'cil-file'
        },
      ],
    },
    {
      module: ModuleId.Blog,
      group: i18nMessage.Blog,
      items: [
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.BlogCategories,
          to: '/blog-category',
          icon: 'cil-clear-all'
        },
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.Blogs,
          to: '/blog',
          icon: 'cil-short-text'
        },
      ],
    },
    {
      module: ModuleId.EmailBuilder,
      group: i18nMessage.Email,
      items: [
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.EmailBuilders,
          to: '/email-builder',
          icon: 'cil-envelope-letter'
        },
      ],
    },
    {
      module: ModuleId.Image,
      group: i18nMessage.Component,
      items: [
        {
          _name: 'CSidebarNavItem',
          name: i18nMessage.Images,
          to: '/image',
          icon: 'cil-image'
        },
      ]
    }
  ]
  
  const rootNav = {
    _name: 'CSidebarNav',
    _children: []
  }
  
  const isLoggedIn = loggedInUser && loggedInUser.id && loggedInUser.id.length > 0
  const hasModules = isLoggedIn && loggedInUser.modules && loggedInUser.modules.length > 0
  
  const enabledModuleMap = {}
  if (hasModules) {
    for (const module of loggedInUser.modules) {
      enabledModuleMap[module] = true
    }
  }
  
  const groupFlag = {}
  for (const conf of navConf) {
    const enabled = isLoggedIn && (!hasModules || (conf.module in enabledModuleMap && enabledModuleMap[conf.module]))
    if (enabled) {
      if (!conf.group in groupFlag || !groupFlag[conf.group]) {
        rootNav._children.push(      {
          _name: 'CSidebarNavTitle',
          _children: [conf.group]
        })
        groupFlag[conf.group] = true
      }
      for (const item of conf.items) {
        rootNav._children.push(item)
      }
    }
  }

  return [ rootNav ]
}